import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import type { ShipmentAdditionalDetails } from "~/shared/schemas/shipment-management-schema";
import { formatSourceDate } from "~/shared/utils/date-formatter.ts";

import * as styles from "./details-modal.module.css";

export const SourceUser = ({
	source,
}: {
	source: ShipmentAdditionalDetails["quoteSource"];
}) => {
	const name = source?.name?.trim() || source?.user?.trim();
	const email = source?.email?.trim();

	if (!name && !email) {
		return <span className={styles.detailValue}>N/A</span>;
	}

	return (
		<span className={styles.detailValue}>
			{name ? <span className={styles.userLine}>{name}</span> : null}
			{email ? <span className={styles.userLine}>{email}</span> : null}
		</span>
	);
};

export const AdditionalDetailsModal = ({
	onClose,
	isOpen,
	details,
	quoteId,
}: {
	onClose: () => void;
	isOpen: boolean;
	details?: ShipmentAdditionalDetails;
	quoteId?: number | null;
}) => {
	const handleConfirm = () => {
		onClose();
	};

	if (!isOpen || !details) {
		return null;
	}

	return (
		<TraxModal
			className={styles.additionalDetailsModal}
			confirmText={"Close"}
			onCancel={() => {
				onClose();
			}}
			onClose={() => {
				onClose();
			}}
			onConfirm={handleConfirm}
			title={"Additional Details"}
			type={"primary"}
			width={338}
		>
			<div className={styles.sections}>
				<div className={styles.section}>
					<h2 className={styles.sectionTitle}>Quote Source</h2>
					<div className={styles.details}>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>Origin</span>
							<span className={styles.detailValue}>
								{details.quoteSource?.origin ?? "N/A"}
							</span>
						</div>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>User</span>
							<SourceUser source={details.quoteSource} />
						</div>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>Date</span>
							<span className={styles.detailValue}>
								{formatSourceDate(details.quoteSource?.date)}
							</span>
						</div>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>Quote ID</span>
							<span className={styles.detailValue}>{quoteId ?? "N/A"}</span>
						</div>
					</div>
				</div>
				<div className={styles.section}>
					<h2 className={styles.sectionTitle}>Tender Source</h2>
					<div className={styles.details}>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>Origin</span>
							<span className={styles.detailValue}>
								{details.tenderSource?.origin ?? "N/A"}
							</span>
						</div>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>User</span>
							<SourceUser source={details.tenderSource} />
						</div>
						<div className={styles.detailRow}>
							<span className={styles.detailLabel}>Date</span>
							<span className={styles.detailValue}>
								{formatSourceDate(details.tenderSource?.date)}
							</span>
						</div>
					</div>
				</div>
			</div>
		</TraxModal>
	);
};
